module.exports = __webpack_public_path__ + "static/media/home.4e630aca.svg";